import Axios from '@/libs/services'

const Request = new Axios()

const service = ''
const version = 'v1'

class SettingsService {
  getMe = () => {
    const uri = 'me/'
    const service = 'accounts'

    return Request.get({ service, uri, version })
  }

  updateMe = body => {
    const uri = 'me/'
    const service = 'accounts'

    return Request.patch({ body, service, uri, version })
  }

  changePassword = (oldPassword, newPassword) => {
    const uri = 'password/'
    const service = 'accounts'

    return Request.post({ body: { oldPassword, newPassword }, service, uri, version })
  }

  getOrganization = () => {
    const service = 'organizations/'

    return Request.get({ service, version })
  }

  createOrganization = ({ body, logoFile }) => {
    const service = ''
    const uri = 'organizations/'

    return Request.post({
      body,
      files: { logo: logoFile },
      service,
      uri,
      version,
      skipSnakeCase: true,
    })
  }

  updateOrganization = (organizationId, body, logoFile) => {
    const service = ''
    const uri = `organizations/${organizationId}/`

    const req = { body, service, uri, version }

    if (logoFile) {
      req.files = { logo: logoFile }
    }

    return Request.put(req)
  }

  getTimezones = (search = '') => {
    const uri = `timezones/?q=${search}`
    return Request.get({ version: 'v2', service, uri })
  }

  /**
   * Request account deletion. Sends a confirmation email to the user.
   * Throttled to 1 request per 24h per user (202 success, 429 if throttled).
   */
  requestAccountDeletion = () => {
    const uri = 'accounts/delete-request/'
    return Request.post({ version: 'v2', service: '', uri, body: {} })
  }

  /**
   * Confirm account deletion (email link). GET with token; no auth.
   */
  confirmAccountDeletion = token => {
    const uri = 'accounts/delete-confirm/'
    return Request.get({ version: 'v2', service: '', uri, query: { token }, skipAuth: true })
  }

  /**
   * Recover account within retention window (email link). GET with token; no auth.
   */
  recoverAccount = token => {
    const uri = 'accounts/delete-recover/'
    return Request.get({ version: 'v2', service: '', uri, query: { token }, skipAuth: true })
  }

  getIndustries = () => {
    const uri = 'industries/'
    return Request.get({ version, service, uri })
  }

  getCountries = () => {
    const uri = 'countries/'
    return Request.get({ version, service, uri })
  }
}

export default new SettingsService()
